import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  SoilMoisture1,
  SoilMoisture2,
  Moisture1,
  Moisture2,
  AirTemperature,
  AirHumidity,
  SoilTemperature,
  AirPressure,
  LeafWetness,
  LightIntensity,
  WindSpeed,
  Rainfall,
  DeltaT,
  VPD,
} from "./sensors";
import { t } from "../../services/locale.service";
import {  ScreenHeader } from "react-library";
import "./org-plot-chart.css";
import Diseases from "./diseases";

const OrgPlotChart = () => {
  const { sensor } = useParams();
  const location = useLocation();

  const { state } = location;
  const { sensorName, isDisease, isPest } = state;

  const SensorGraph = SensorGraphMapping[sensor!];
  const headerTitle = sensorName + " " + t("Details");

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
    };
  }, []);
 

  const handleBack = () => {
    try {
      window.history.back();
    } catch (error) {
      console.log(error);      
    }
  };

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
    };
  }, []);

  return (
    <div className={"container"}>
      <ScreenHeader screenName={headerTitle} />
      <div className="dataContainer">
        {SensorGraph && (
          <SensorGraph />
        )}  

        { isDisease && (
          <Diseases />
        )}

        {
          isPest && <Diseases />
        }
      </div>
    </div>
  );
};

export default OrgPlotChart;

/**
 * ================== TYPES ======================
 */
type TComponentMapping = Record<
  string,
  React.FC
>;


/**
 * ================== Sensor Component Mapping ======================
 */
const SensorGraphMapping: TComponentMapping = {
  soilMoisture1: SoilMoisture1,
  soilMoisture2: SoilMoisture2,
  moisture1: Moisture1,
  moisture2: Moisture2,
  airTemp: AirTemperature,
  airHumidity: AirHumidity,
  soilTemp: SoilTemperature,
  airPressure: AirPressure,
  leafWetness: LeafWetness,
  lightIntensity: LightIntensity,
  rainFall: Rainfall,
  windSpeed: WindSpeed,
  deltaT: DeltaT,
  VPD: VPD
};